<tilby-dialog-toolbar title="{{'SETTINGS.SETTINGS.AUTOMATIC_PRINT_SETTINGS_TITLE' | translate}}"
    (confirm)="confirm()"
    [hideConfirm]="!automaticPrintSettingsForm.valid"
 />
<tilby-dialog-content>
    <tilby-magic-form [form]="automaticPrintSettingsForm"/>
</tilby-dialog-content>


